import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { CHANGE_PASSWORD } from "redux-store/users/actions";
import { SettingsPage } from "view/account/settings";

function mapDispatchToProps(dispatch) {
  return {
    changePassword: (p1, p2) => {
      return createPromiseApiAction(dispatch, CHANGE_PASSWORD, [p1, p2]);
    },
  };
}

const ConnectedSettingsPage = connect(null, mapDispatchToProps)(SettingsPage);

export { ConnectedSettingsPage };
